import { createStore } from '~/store/createStore'

export const useSymbolDictionaryStore = createStore<{
  dictionary: { [x: string]: string }
}>((set, get) => {
  return {
    dictionary: {},
  }
})
